import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';

export default () => (
    <div className="min-h-screen bg-gray-200 overflow-hidden flex items-center">
      <CircularProgress />
    </div>
);
